//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubmitCodeModal',
  props: {
    email: {
      type: String,
      default: ''
    },
    jobId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      code: ''
    }
  },
  methods: {
    async resendCode () {
      await this.$axios.post('/api/jobs/resend-code', {
        email: this.email, jobId: this.jobId
      }).catch((resp) => {
        console.log(resp.data)
      })
      this.$toast.success(this.$t('submitted'))
    },
    async sendCode () {
      if (this.code) {
        const result = await this.$axios.post('/api/jobs/check-code', {
          code: this.code, email: this.email, jobId: this.jobId
        }).catch((resp) => {
          console.log(resp.data)
        })
        if (result.data.message === 'success') {
          window.localStorage.setItem('jobsCode', this.code)
          this.$nuxt.$emit('successJobPost')
          this.$modal.hide('submit-code-modal')
        }
      }
    }
  }
}
